import styled from 'styled-components';

export const Container = styled.div`
	display: -ms-inline-flexbox;
	display: -webkit-inline-box;
	display: -webkit-inline-flex;
	display: inline-flex;
	height: 24px;
	margin: 0 1.5rem;
	position: absolute;
	right: 0;
	width: 24px;
`;

export const Content = styled.div`
	padding: 0.625rem 1rem;
`;

export const Card = styled.div`
	width: 450px;
	background: #ffffff;
	position: absolute;
	right: 0;
	top: 30px;
	-webkit-box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
		0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14);
	box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
		0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14);
`;

export const List = styled.ul`
	display: flex;
	flex-direction: column;
	padding: 0;
	list-style: none;
`;

export const ListItem = styled.li`
	display: flex;
	align-items: center;
	padding: 0.625rem 1rem;

	-webkit-tap-highlight-color: transparent;
	-webkit-transition: background-color;
	transition: background-color;
	-webkit-transition-duration: 200ms;
	transition-duration: 200ms;
	cursor: pointer;

	:hover {
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

export const FooterList = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-top: 1px solid rgba(0, 0, 0, 0.4);
	padding: 0.625rem 0;
`;

export const Icon = styled.i`
	color: ${(props) => props.theme.colors.linkLabel} !important;	
	font-size: 24px;
	margin-right: 0.5rem;
`;

export const Text = styled.p`
	font-size: 0.875rem;
	margin: 0;
`;

export const Button = styled.button`
	border-width: 0;
	background: transparent;

	justify-content: center;
	align-items: center;
	min-width: 5.5rem;
	height: 2.25rem;
	padding: 0 1rem;
	border: none;
	border-radius: 4px;
	font-size: 0.875rem;
	font-weight: 700;
	line-height: 1.5rem;
	text-align: center;
	text-decoration: none;
	outline: none;
	cursor: pointer;
	-webkit-tap-highlight-color: transparent;
	-webkit-transition: background-color;
	transition: background-color;
	-webkit-transition-duration: 200ms;
	transition-duration: 200ms;

	:hover {
		background: rgba(0, 91, 148, 0.1);
	}
`;
